import api from './api';

export const getChecklists = (params = {}) => api.get('/quality/checklists', { params });

export const getChecklist = (id) => api.get(`/quality/checklists/${id}`);

export const createChecklist = (data) => api.post('/quality/checklists', data);

export const updateChecklist = (id, data) => api.put(`/quality/checklists/${id}`, data);

export const cloneChecklistToProject = (id, data) => api.post(`/quality/checklists/${id}/clone-to-project`, data);

export const getInspections = (params = {}) => api.get('/quality/inspections', { params });

export const getInspection = (id) => api.get(`/quality/inspections/${id}`);

export const createInspection = (data) => api.post('/quality/inspections', data);

export const updateInspection = (id, data) => api.put(`/quality/inspections/${id}`, data);

export const signOffInspection = (id, data) => api.put(`/quality/inspections/${id}/sign-off`, data);

// Record or correct an inspection's result (pending/passed/failed) - the
// step before Sign Off, which only accepts "passed". Also how a wrongly
// recorded result gets recalled (set back to "pending").
export const setInspectionResult = (id, status, findings) =>
  api.put(`/quality/inspections/${id}/result`, { status, findings });

export const getInspectorPerformance = (inspectorId, month) =>
  api.get(`/quality/inspector-performance/${inspectorId}`, { params: month ? { month } : {} });

export const checkChecklistItem = (checklistId, itemId, checked, checkedById, stage = 'production') =>
  api.put(`/quality/checklists/${checklistId}/items/${itemId}/check`, { checked, checked_by_id: checkedById, stage });

// Every checklist item production has checked but quality hasn't verified
// yet, across all projects - the queue quality works from instead of
// hunting through each project's checklist individually.
export const getPendingVerification = () => api.get('/quality/checklists/pending-verification');
